import { useNavigate } from 'react-router-dom'

import type { Option } from 'modules/core/components/Popover/Content'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { useAttendanceContextlessPolicies } from 'modules/attendance/hooks/useAttendanceContextlessPolicies'
import { useTimesheetData } from 'modules/attendance/lib/timesheetDataContext'

interface HeaderActionsResult {
  headerOptions: Option[]
}

const useHeaderActions = (): HeaderActionsResult => {
  const navigate = useNavigate()
  const { currentEmployeesSetting } = useTimesheetData()
  const { accessEditSettings } = useAttendanceContextlessPolicies()
  const { navigation } = useNavigation()

  const options = []

  if (accessEditSettings && currentEmployeesSetting?.id) {
    const routeParams = {
      id: 'time_tracking',
      settingId: currentEmployeesSetting?.id.toString() ?? 'default',
      tabId: 'edit',
    }
    const route = navigation.settings.time_tracking.settingId.tabId.fullPath(routeParams)

    options.push({
      title: i18n.t('clock_in.header.options.title'),
      onClick: () => navigate(route),
      description: i18n.t('clock_in.header.options.description'),
    })
  }

  return {
    headerOptions: options,
  }
}

export default useHeaderActions
